// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__2o472","itemTitle":"ClientEmergencyInfo_itemTitle__129eP","itemText":"ClientEmergencyInfo_itemText__P22ON"};